import styled from "styled-components";

export const CollapseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  & > div {
    width: 100%;
  }
`;

export const TriggersCreatedPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: calc(100vh - 48px);
  overflow: hidden; 
  padding: 0 24px;
`;

export const Content = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  width: 100%;
  max-width: 1400px;
  height: 100%;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 48px - 60px - 270px); 

  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  table {
    width: 100%;
  }

  /* Name column */
  table thead th:nth-child(1) {
    width: 200px;
  }

  /* Type column */
  table thead th:nth-child(2) {
    width: 150px;
  }

  /* Description column */
  table thead th:nth-child(3) {
    width: 250px;
  }

  /* Created By column */
  table thead th:nth-child(4) {
    width: 150px;
  }

  /* Last Updated column */
  table thead th:nth-child(5) {
    width: 150px;
  }

  /* Enrolled column */
  table thead th:nth-child(6) {
    width: 120px;
  }

  /* Source column */
  table thead th:nth-child(7) {
    width: 120px;
  }

  /* Channel column */
  table thead th:nth-child(8) {
    width: 120px;
  }

  /* Status column */
  table thead th:nth-child(9) {
    width: 100px;
  }

  /* Actions column (dropdown) - smallest */
  table thead th:last-child {
    width: 80px;
  }
`;

export const NoDataWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    font-family: ${(props) => props.theme.fonts.family.inter};
`      

export const NoDataTitle = styled.p`
    font-size: 20px;
    font-weight: 600;
    text-align: center;
`

export const NoDataDescription = styled.p`
    margin:0;
    font-size: 14px;
    color: ${(props) => props.theme.colors.davysGrey};
    text-align: center;
`
export const LoaderWrapper = styled.div`
  width: 100%;
  min-height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NameWithVisibilityContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  .gray-icon img {
    filter: grayscale(100%) brightness(0.6);
  }
`;

export const UnderlinedText = styled.span`
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-thickness: 1px;
`;

export const NodesContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
`;

export const CircularContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;  
  height: 100%;
`

export const DropdownWrapper = styled.div`
    max-width: 26px;
    @media screen and (min-width: 2560px) and (max-width: 2560px) {
        & > div > div:last-child {
            left: auto !important;
            right: 0px !important;
        }
    }
`